<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wsd3J7/tc-custom/9781504073431.jpg?1700680417284" alt="This image is the cover for the book Man Could Stand Up, The Parade's End Tetralogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Man Could Stand Up, The Parade's End Tetralogy
      </h1>
      <p class="bookDescription body article font2">
        <p><b>As WWI ends, trauma and tragedy give way to a chance for new life and rekindled love in the third novel of the acclaimed Parade’s End tetralogy. </b></p><p><i>Armistice Day, 1918</i>. As fireworks proclaim the end of the Great War, Valentine Wannop learns that the man she loves, Christopher Tietjens, is back in London. He has survived the frontlines, but it has affected him profoundly. He is willing to give up everything to be with Valentine, but they are not yet free of the past.</p> Arranging to meet at Gray’s Inn, Christopher and Valentine are thwarted by Valentine’s mother, who will stop at nothing to keep them apart. As other men from Christopher’s unit return, Valentine learns of his terrifying wartime experience . . . and her thoughts return again to his wife he has yet to leave, the beautiful and manipulative Sylvia.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ford Madox Ford
      </h2>
      
      <p class="authorDescription body article">Ford Madox Ford was an English novelist, poet, critic, and editor whose journals&#160;<I>The English Review</I>&#160;and&#160;<I>The Transatlantic Review</I>&#160;were instrumental in the development of early twentieth-century English literature. Today, Ford is best known for&#160;<I>The Good Soldier</I>, the Parade&rsquo;s End Tetralogy, and the Fifth Queen Trilogy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?50aff378